/* file description */

import type { UseSetVal } from './type';
import { COLUMN_FROM } from '../../../effects/consts';

export const useSetVal: UseSetVal = ({ onChange, field, form, config, columnFrom, treeData }) => {

  const { showFields = [], options = [] } = field?.bizConfig || {};

  const setShowFieldsValue = (type: string, selectData: Record<any,any>) => {
    // 联动展示字段
    showFields.forEach((item: { key: any; realLabel: any }) => {
      const values: Record<any,any> = {}
      const setName = `${field.name}_LINK_${item?.key}`
      if (columnFrom === COLUMN_FROM.FORM) {
        values[setName] = type === 'reset' ? '' : selectData[item?.key]
        form.setFieldsValue(values)
      }
      if (columnFrom === COLUMN_FROM.TABLE) {
        const tableKey = config.rowIndex
        values[tableKey] = {}
        values[tableKey][setName] = type === 'reset' ? '' : selectData[item?.key]
        form.setFieldsValue(values)
      }
    })
    // 联动保存字段
    options.forEach((item: { moduleField: any; linkField: any }) => {
      const values: Record<any,any> = {}
      if (columnFrom === COLUMN_FROM.FORM) {
        values[item.moduleField] = type === 'reset' ? '' : selectData[item.linkField]
        form.setFieldsValue(values)
      }
      if (columnFrom === COLUMN_FROM.TABLE) {
        const tableKey = config.rowIndex
        values[tableKey] = {}
        values[tableKey][item.moduleField] = type === 'reset' ? '' : selectData[item.linkField]
        form.setFieldsValue(values)
      }
    })
  }

  const selectTree = (val: string | number) => {
    onChange?.(val)
    if (val) {
      const selectData = treeData.find((item:any) => item.value === val) || {}
      setShowFieldsValue('set', selectData)
    } else {
      setShowFieldsValue('reset', {})
    }
  }
  return {
    selectTree,
  };
};
